import React, { useRef, useState } from 'react';
import * as Icon from 'ubs-icons';
import { bytesToSize, getThumbor } from "../common/function";
import { COLOR, FILE } from "../common/constant";
import UPopup from "ubs-framework/v2/UPopup";
import PropTypes from "prop-types";
import { useUFramework } from '../context';
import UFilePreview from './file-preview';

export const getFrameworkFileIcon = (ext, size = 24) => {
    const extension = ext?.toLowerCase();
    if (extension === 'xlsx' || extension === 'xls' || extension === 'csv') {
        return <Icon.ExcelFile className="u_m-auto" fill="#207245" size={size} />;
    } else if (extension === 'pdf') {
        return <Icon.PDF className="u_m-auto" fill={COLOR.u_red} size={size} />;
    } else if (extension === 'docx' || extension === 'doc') {
        return <Icon.DOC className="u_m-auto" fill="#2B579A" size={size} />;
    } else if (['mp4', 'mov', 'avi', 'mkv', 'webm', 'mpg'].includes(extension)) {
        return <Icon.Play className="u_m-auto" fill={COLOR.u_blue} size={size} />;
    } else if (['mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac'].includes(extension)) {
         return <Icon.Music className="u_m-auto" fill={COLOR.u_blue} size={size} />;
    } else {
        return <Icon.FilePreview className="u_m-auto" fill={COLOR.u_icon_bg} size={size} />;
    }
};

const UFileInfo = React.memo((props) => {
    const _S3_BASE_URL = useUFramework(e => e?.S3_BASE_URL)

    return (
        <React.Fragment>
            <div className="u_fv">
                {props?.mode === 'thumb' ? <div className="u_fv-thumb">
                    {(FILE.IMAGES.test(props?.file?.url)) ? <img src={(props?.file?.url?.startsWith('blob:') || props?.file?.url?.startsWith('data:')) ? props?.file?.url : (getThumbor('32x32') + _S3_BASE_URL + props?.file?.url)} alt={props.alt} />
                        :
                        <div className="u_fv-thumb-icon">
                            <div className="u_m-auto u_text-center" style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center' }}>
                                {getFrameworkFileIcon(props?.file?.ext)}
                                <p className="u_font u_mt-5" style={{ fontSize: '10px' }}>{props?.file?.ext}</p>
                            </div>
                        </div>
                    }
                    <UFileAction
                        action={props?.action}
                        file={props?.file}
                        files={props?.files}
                        initialIndex={props?.initialIndex}
                        onDelete={props?.onDelete}
                    />
                </div> :
                    <div className="u_fv-detail">
                        <div className="u_fv-icon">
                            <span className="u_m-auto u_text-center" style={{ display: 'flex' }}>
                                {getFrameworkFileIcon(props?.file?.ext)}
                            </span>
                        </div>
                        <div className="u_fv-content">
                            <p className="u_file-name u_one-line u_mb-5">{props?.file?.fileName || '-'}</p>
                            <p className="u_small-font">{props?.file?.size ? bytesToSize(props?.file?.size) : null}</p>
                        </div>
                        <UFileAction
                            action={props?.action}
                            file={props?.file}
                            files={props?.files}
                            initialIndex={props?.initialIndex}
                            onDelete={props?.onDelete}
                        />
                    </div>}
            </div>
        </React.Fragment>
    );
});

const UFileAction = React.memo((props) => {
    const _S3_BASE_URL = useUFramework(e => e?.S3_BASE_URL)

    const [open, setOpen] = useState(false)

    const handle = {
        download: file => {
            let iframe = document.createElement("iframe");
            iframe.style.visibility = "collapse";
            document.body.append(iframe);
            const url = (file.url?.startsWith('blob:') || file.url?.startsWith('data:')) ? file.url : _S3_BASE_URL + file.url;
            // eslint-disable-next-line
            iframe.contentDocument.write(`<form action="${url.replace(/\"/g, '"')}" method="GET"/>`);
            iframe.contentDocument.forms[0].submit();
            setTimeout(() => iframe.remove(), 2000);
        }
    }
    return <React.Fragment>
        <div className="u_fv-action">
            {props?.action.includes('view') && <UPopup params={{ className: "u_tooltip u_tooltip-full", on: ['hover'] }} desc={<span className='u_text-c'>View</span>}>
                <div className="u_cp u_mx-5" onClick={() => setOpen(true)}>
                    <Icon.Eye size={16} fill={COLOR.u_blue} />
                </div>
            </UPopup>}


            {props?.action.includes('download') && <a href={(props?.file.url?.startsWith('blob:') || props?.file.url?.startsWith('data:')) ? props?.file.url : (_S3_BASE_URL + props?.file.url)} className=" u_lh-0" target="_blank" rel="noopener noreferrer">
                <UPopup params={{ className: "u_tooltip u_tooltip-full", on: ['hover'] }} desc={<span className='u_text-c'>Download</span>}>
                    <div className="u_cp u_mx-5">
                        <Icon.Download size={16} fill={COLOR.u_blue} />
                    </div>
                </UPopup>
            </a>}
            {props?.action.includes('delete') &&
                <UPopup params={{ className: "u_tooltip u_tooltip-full", on: ['hover'] }} desc={<span className='u_text-c'>Delete</span>}>
                    <div className="u_cp u_mx-5" onClick={() => props.onDelete()}>
                        <Icon.Delete size={16} fill={COLOR.u_blue} />
                    </div>
                </UPopup>}
        </div>
        {open && <UFilePreview file={props?.file} files={props?.files} initialIndex={props?.initialIndex} onClose={() => setOpen(false)} onDelete={props?.action?.includes('delete') ? props?.onDelete : undefined} />}
    </React.Fragment>
})

UFileInfo.propTypes = {
    action: PropTypes.array,
    mode: PropTypes?.string,
    onDelete: PropTypes?.func
}
UFileInfo.defaultProps = {
    action: ['view', 'download'],
    mode: "thumb", // thumb | detail
    onDelete: () => null
};

export default UFileInfo;
